<template lang="html">
  <div class="home-index">
    <van-skeleton
      title
      avatar
      :row="20"
      :loading="loading">

      <van-swipe :autoplay="5000" class="home-swipe" >
        <van-swipe-item v-for="(image, index) in imageList" :key="index">
          <img :src="image">
        </van-swipe-item>
      </van-swipe>

      <van-search 
        v-model="searchKey"
        shape="round"
        placeholder="搜索"
      />
      <div style="background-color: #fff; margin-bottom: 10px;">
        <van-grid :column-num="5" :border="false" >
          <van-grid-item  v-for="(item) in categoryData" :key="item.id" :icon="item.icon" :text="item.name" :to="{ path: '/openCourseCategory/'+ item.id}" />
        </van-grid>
      </div>

    </van-skeleton>
    <div style="background-color: #fff;  margin-bottom:55px;" v-show="divShow === 'consultant'">
      <van-cell title-style="text-align:left;font-weight:bold;font-size:18px;"  title="最新课程" value="更多" >
        <template #right-icon>
          <van-icon  size="12" :name="require('@/assets/icon/Vector.png')" style="line-height: inherit;"  />
        </template>
      </van-cell>
      <van-grid :column-num="2" :border="false" :gutter="5"  >
        <van-grid-item  v-for="(item) in lastestData" :key="item.id" class="course-item" :to="{ path: '/openCourse/'+ item.id}" >
          <van-image fit="cover" :src="item.coverUrl" class="new-course-image" />
          <div style="text-align: left; width: 100%;">
            <span class="course-title">{{item.name.length > 30 ? item.name.substring(0,30) : item.name}}</span>
            <span class="course-subtitle">{{item.content.length > 20 ? item.content.substring(0,20) : item.content}}</span>
            <span class="course-price">{{item.registrationAmount}}</span>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <div style="margin-bottom: 55px;" v-show="divShow === 'teacher'">
      <van-cell title-style="text-align:left;font-weight:bold;font-size:18px;"  title="教师开课课程" value="全部课程" >
        <template #right-icon>
          <van-icon  size="12" :name="require('@/assets/icon/Vector.png')" style="line-height: inherit;"  />
        </template>
      </van-cell>
      <van-grid :column-num="2" :border="false" v-show="teacherGridData && teacherGridData.length > 0" >
        <van-grid-item  v-for="(item) in teacherGridData"  :key="item.id"  :to="{ path: '/openCourse/'+ item.id}">
          <van-image fit="cover" :src="item.coverUrl" class="new-course-image" />
          <div style="text-align: left; width: 100%;">
            <span class="course-title">{{item.name.length > 30 ? item.name.substring(0,30) : item.name}}</span>
            <span class="course-subtitle">{{item.content.length > 20 ? item.content.substring(0,20) : item.content}}</span>
            <span class="course-price">{{item.registrationAmount}}</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-empty description="暂无已发布的课程" v-show="!(teacherGridData && teacherGridData.length > 0)" />
    </div>
  </div>

</template>

<script>
export default {
  data () {
    return {
      count: 0,
      activeNames: ['1'],
      page: {
        current: 1,
        size: 6
      },
      divShow: 'consultant',
      show: true,
      searchKey:"",
      lastestData: [],
      categoryData: [],
      images: [
        'https://img.yzcdn.cn/1.jpg',
        'https://img.yzcdn.cn/2.jpg'
      ],
      imageList: [
        require('@/assets/banner-2.png'),
        require('@/assets/banner-1.png')
      ],
      teacherGridData:[],
      loading: true,
      gridData: [
        {"title":"在线课程","image":require('@/assets/jgq/PlaySquare.png')},
        {"title":"综合管理","image":require('@/assets/jgq/Appstore.png')},
        {"title":"非财高管","image":require('@/assets/jgq/Solution.png')},
        {"title":"管理会计","image":require('@/assets/jgq/Edit.png')},
        {"title":"公司金融","image":require('@/assets/jgq/BarChart.png')},

        {"title":"风险管理","image":require('@/assets/jgq/Stock.png')},
        {"title":"信息技术","image":require('@/assets/jgq/Profile.png')},
        {"title":"会计准则","image":require('@/assets/jgq/LineChart.png')},
        {"title":"税务管理","image":require('@/assets/jgq/Transaction.png')},
        {"title":"公共管理","image":require('@/assets/jgq/Setting.png')},
      ],
      commendData: [
        {"title":"财务测试课程","subtitle":"课程简介用故事思维打动","price":"￥99.90","image":require('@/assets/course-2/1.png')},
        {"title":"财务测试课程2","subtitle":"课程简介用故事思维打动","price":"￥99.90","image":require('@/assets/course-2/2.png')},
        {"title":"会计就业速成班","subtitle":"课程简介用故事思维打动","price":"￥99.90","image":require('@/assets/course-2/3.png')},
        {"title":"实战税法训练营","subtitle":"课程简介用故事思维打动","price":"￥99.90","image":require('@/assets/course-2/4.png')},
      ],
      commendData2: [
        {"title":"财务测试课程","subtitle":"课程简介用故事思维打动","price":"￥99.90","image":require('@/assets/course-2/5.png')},
        {"title":"财务测试课程2","subtitle":"课程简介用故事思维打动","price":"￥99.90","image":require('@/assets/course-2/6.png')},
        {"title":"会计就业速成班","subtitle":"课程简介用故事思维打动","price":"￥99.90","image":require('@/assets/course-2/7.png')},
        {"title":"实战税法训练营","subtitle":"课程简介用故事思维打动","price":"￥99.90","image":require('@/assets/course-2/8.png')},
      ],
    }
  },
  created() {
  },
  mounted() {
    this.$api.course.getPublishCategory().then((res) => {
      if (res.code === 200){
        this.categoryData = res.data
      }
    })
    this.divShow = 'consultant';
    this.getConsultantCourse();
  },
  methods: {
    getTeacherCourse(){
      this.$api.teacher.getTeacherPublishCourse().then((res) => {
        this.loading = false
        if (res.code === 200){
          this.teacherGridData = res.data
        }
      });
    },
    getConsultantCourse(){
      this.$api.course.getLatestCourse(this.page).then((res) => {
        this.loading = false
        if (res.code === 200){
          this.lastestData = res.data.records;
        }
      })
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false
        this.count++
      }, 500)
    }
  }
}
</script>

<style lang="less" scoped>

.home-swipe {
  background-color:#fff;
  img {
    width: 100vw;
  }
}
.custom-title{
  margin-top:10px;
  font-size:14px;
}
.new-course-image{
  width:100%;
}
.course-title,.course-subtitle,.course-price{ display:block;font-size:16px; padding:3px 0;font-weight:bold;}
.course-title{ color:000; }
.course-subtitle{color: #00000073; font-size:14px;}
.course-price{color: #e85728;}
.van-search__content{ background-color: #fff; border:1px solid #eee;  }
</style>
<style>
  .course-item .van-grid-item__content{ height:auto; padding-bottom: 5px; padding-top: 10px;}
</style>
